module.exports = __webpack_public_path__ + "img/04_sub_uk.7676ae64.svg";